const getUrlParameter = (name: string): string | undefined => {
  const match = new RegExp(`[?|&]${name}=([^&;]+?)(&|#|;|$)`).exec(window.location.search);
  return decodeURIComponent(((match && match[1]) || '').replace(/\+/g, '%20')) || undefined;
};

export default getUrlParameter;
